import { render } from "./photo-card.vue?vue&type=template&id=53451990&scoped=true&ts=true"
import script from "./photo-card.vue?vue&type=script&lang=ts"
export * from "./photo-card.vue?vue&type=script&lang=ts"

import "./photo-card.vue?vue&type=style&index=0&id=53451990&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53451990"]])

export default __exports__